import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a769b5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal__root"
}
const _hoisted_2 = { class: "inner" }

import ModalClose from "@/assets/icons/modalClose.vue";
import { watch, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheModal',
  props: {
	title: String,
	show: Boolean,
},
  emits: ["update:show"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;
const emit = __emit;

const showModal = ref(false);

// watch show change
watch(
	() => props.show,
	(v) => {
		if (v) {
			requestAnimationFrame(() => {
				showModal.value = v;
			});
		}
	}
);

const CloseModal = () => {
	showModal.value = false;
	setTimeout(() => {
		emit("update:show", false);
	}, 500);
};

__expose({
	CloseModal,
});

return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass([showModal.value ? 'mask show' : 'mask']),
          onClick: CloseModal
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass([showModal.value ? 'modal show' : 'modal'])
        }, [
          _createElementVNode("header", null, [
            _createTextVNode(_toDisplayString(__props.title) + " ", 1),
            _createVNode(ModalClose, { onClick: CloseModal })
          ]),
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}
}

})